// Components
import { ClearFilters } from "Components/Users/ClearFilters";
// Hooks
import useDateRange from "hooks/useDateRange";
// Store utils
import { useDispatch } from "react-redux";
// External Tools
import { sentenceCase } from "change-case";
import { notificationsScheduledForAction } from "store/filters/reducer.actions";

interface DateProps {
  name: string;
  scheduledFor: string;
  isApplied: boolean;
}
// Defining the Date component as a functional component that receives DateProps.
export const Date: React.FC<DateProps> = ({
  name,
  scheduledFor,
  isApplied,
}) => {
  const dispatch = useDispatch(); // Initializing the Redux dispatch function.
  const { getSingleDateOption } = useDateRange(); // Using the useDateRange hook to get the getDateOption function.

  // Defining a function to reset the filter when ClearFilters is clicked.
  const resetFilter = () => {
    dispatch(notificationsScheduledForAction(""));
  };

  if (!isApplied) {
    return null;
  }

  if (scheduledFor === "Invalid date") {
    dispatch(notificationsScheduledForAction(""));
  }
  return (
    <div
      className="flex justify-between px-2  items-center gap-1 flex-grow-0 flex-shrink-0 relative  
 rounded-lg bg-primary_8"
    >
      <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative px-1 pt-1.5 pb-2">
        <p className="flex-grow-0 flex-shrink-0 text-sm text-center text-secondaryMid dark:text-inputText">
          {sentenceCase(name)}: {getSingleDateOption(scheduledFor)}
        </p>
      </div>
      <ClearFilters handleClick={resetFilter} />
    </div>
  );
};
